import { useQuery } from "@tanstack/react-query"
import { listPluginEnvironments, listPlugins } from "sdk/plugins"

export const pluginKeys = {
  all: ["plugins"],
  list: (...params) => [...pluginKeys.all, ...params],
  detail: id => [...pluginKeys.all, id]
}

export const pluginEnvironmentKeys = {
  all: ["pluginEnvironments"],
  list: (...params) => [...pluginEnvironmentKeys.all, ...params],
  detail: id => [...pluginEnvironmentKeys.all, id]
}

export function useListPluginEnvironments() {
  return useQuery({
    queryKey: pluginEnvironmentKeys.list(),
    queryFn: listPluginEnvironments
  })
}

export function useMediaGalleryPlugins(options = {}) {
  return useQuery({
    queryKey: pluginKeys.list({ env: "media_gallery" }),
    queryFn: () => listPlugins({ env: "media_gallery" }),
    ...options
  })
}

export function useRuleTriggerPlugins(options = {}) {
  return useQuery({
    queryKey: pluginKeys.list({ env: "rule_triggers" }),
    queryFn: () => listPlugins({ env: "rule_triggers" }),
    ...options
  })
}

export function useVaEventPlugins(options = {}) {
  return useQuery({
    queryKey: pluginKeys.list({ env: "va_events" }),
    queryFn: () => listPlugins({ env: "va_events" }),
    ...options
  })
}
